var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "nav",
      { staticClass: "navbar navbar-expand-lg navbar-light fixed-top" },
      [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse",
              attrs: { id: "navbar5" },
            },
            [
              _vm.isLoggedIn
                ? _c(
                    "ul",
                    { staticClass: "navbar-nav ml-auto text-center" },
                    [
                      _vm._l(_vm.authlinks, function (link) {
                        return _c(
                          "router-link",
                          {
                            key: link.text,
                            staticClass: "nav-item",
                            attrs: { to: link.route },
                          },
                          [
                            _c("a", { staticClass: "nav-link" }, [
                              _vm._v(_vm._s(link.text)),
                            ]),
                          ]
                        )
                      }),
                      _c(
                        "li",
                        {
                          staticClass: "dropdown",
                          attrs: { role: "presentation" },
                        },
                        [
                          _vm._m(2),
                          _c("ul", { staticClass: "dropdown-menu" }, [
                            _c(
                              "li",
                              { staticClass: "nav-item" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "nav-item",
                                    attrs: { to: "/dashboard/cadastro" },
                                  },
                                  [
                                    _c(
                                      "a",
                                      { staticClass: "btn btn-link mx-auto" },
                                      [_vm._v("Meu Cadastro")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "li",
                              {
                                staticClass: "nav-item",
                                on: { click: this.ActionDoLogout },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-link mx-auto",
                                    staticStyle: {
                                      "margin-left": "15px",
                                      cursor: "pointer",
                                    },
                                  },
                                  [_vm._v("Sair")]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]
    ),
    _c("div", { attrs: { id: "inside" } }, [_c("router-view")], 1),
    _c("div", { staticClass: "footer1 py-5" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row", attrs: { width: "100%" } }, [
          _c("div", { class: [this.largura < 800 ? "col-1" : "col-2"] }),
          _c(
            "div",
            {
              class: [
                this.largura < 800
                  ? "p-3 col-lg-6 col-4 col-md-4"
                  : "p-3 col-lg-6 col-8 col-md-4",
              ],
            },
            [
              _vm._m(3),
              _c(
                "ul",
                { staticClass: "list-unstyled" },
                [
                  _vm._m(4),
                  _vm._l(_vm.links, function (link) {
                    return _c(
                      "router-link",
                      {
                        key: link.text,
                        attrs: {
                          to: {
                            name: link.route,
                            query: {
                              title: link.text,
                            },
                          },
                        },
                      },
                      [
                        _c("li", [
                          _c("a", { staticStyle: { color: "#1641cc" } }, [
                            _vm._v(_vm._s(link.text)),
                          ]),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
            ]
          ),
          _c(
            "div",
            {
              class: [
                this.largura < 800
                  ? "p-3 col-lg-6 col-7 col-md-4"
                  : "p-3 col-lg-2 col-md-2",
              ],
              staticStyle: { color: "#1641cc" },
            },
            [
              _c("p", { staticClass: "mb-0" }, [_vm._v("Fale conosco:")]),
              _vm._m(5),
              _vm._m(6),
              _vm._m(7),
              _c("hr"),
              _vm._m(8),
              _vm._m(9),
              _vm._m(10),
            ]
          ),
        ]),
        _vm._m(11),
      ]),
    ]),
    _c("div", { staticClass: "nav" }, [
      _c(
        "a",
        {
          staticClass: "nav-link wts bg-success",
          staticStyle: { cursor: "pointer" },
          attrs: { target: "_blank" },
          on: {
            click: function ($event) {
              return _vm.openWhats()
            },
          },
        },
        [_c("i", { staticClass: "fa fa-2x fa-whatsapp text-light" })]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "navbar-brand", attrs: { href: "/dashboard" } },
      [
        _c("img", {
          staticClass: "img-fluid d-block",
          staticStyle: { width: "60%" },
          attrs: { src: "img/logo.png" },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "navbar-toggler navbar-toggler-right border-0",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbar5",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "dropdown-toggle nav-link",
        staticStyle: { "font-size": "14px" },
        attrs: {
          "data-toggle": "dropdown",
          role: "button",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_vm._v(" Cadastro "), _c("i", { staticClass: "fa fa-user fa-fw" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [_c("b", [_vm._v("Tricard")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { staticStyle: { color: "#1641cc" }, attrs: { href: "/" } }, [
        _vm._v("Home"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { staticClass: "btn btn-link", attrs: { href: "tel:+55143235-0900" } },
      [
        _c("i", { staticClass: "fa fa-phone fa-fw mx-1 fa-lg" }),
        _vm._v("(xx) xxxx-xxxx"),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-link",
        attrs: {
          href: "https://api.whatsapp.com/send?l=pt&phone=551132303765",
          target: "_blank",
        },
      },
      [
        _c("i", { staticClass: "fa fa-whatsapp fa-fw mx-1 fa-lg" }),
        _vm._v("(xx) xxxx -xxxx"),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-link",
        attrs: { href: "mailto:xxxx@xxxx.com", target: "_blank" },
      },
      [
        _c("i", { staticClass: "fa fa-envelope-o fa-fw mx-1 fa-lg" }),
        _vm._v("xxxx@xxxx.com"),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-link",
        attrs: {
          href: "https://www.facebook.com/conciligoficial",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-facebook-square fa-fw mx-1 fa-lg" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-link",
        attrs: {
          href: "https://www.instagram.com/concilig_oficial/",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-instagram fa-fw mx-1 fa-lg" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-link",
        attrs: {
          href: "https://www.linkedin.com/company/concilig",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-linkedin fa-fw mx-1 fa-lg" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c("p", { staticClass: "mb-0 mt-2" }, [_vm._v("@tricard")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }